import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import MainPage from './pages/MainPage';
import ServicesPage from './pages/ServicesPage';
import MetersPage from './pages/MetersPage';
import SettingsPage from './pages/SettingsPage';
import ProtectedRoute from './components/common/ProtectedRoute';
import './App.css';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};

const Layout = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      {isAuthenticated && (
        <nav style={{ 
          background: '#333', 
          padding: '10px 20px', 
          color: 'white', 
          marginBottom: '20px', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <div>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Kommunalka</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {user && <span>Привет, {user.user_name || user.email}!</span>}
            <button
              onClick={() => navigate('/settings')}
              style={{
                background: 'transparent',
                border: '1px solid white',
                color: 'white',
                padding: '5px 10px',
                cursor: 'pointer',
                fontSize: '16px',
                borderRadius: '4px'
              }}
              aria-label="Настройки"
              title="Настройки"
            >
              ⚙
            </button>
            <button 
              onClick={logout} 
              style={{ 
                background: 'transparent', 
                border: '1px solid white', 
                color: 'white', 
                padding: '5px 10px', 
                cursor: 'pointer',
                fontSize: '16px',
                borderRadius: '4px'
              }}
            >
              Выйти
            </button>
          </div>
        </nav>
      )}
      <div style={{ padding: '0 20px' }}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<MainPage />} />
            <Route path="/addresses/:addressId/services" element={<ServicesPage />} />
            <Route path="/meters/:serviceId" element={<MetersPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={isAuthenticated ? <Navigate to="/" /> : <Navigate to="/login" />} />
        </Routes>
      </div>
    </>
  );
};

export default App;
